/**
 * Edit text block.
 * @module components/manage/Blocks/Title/Edit
 */

import React from 'react';
import cx from 'classnames';
import { SidebarPortal } from '@plone/volto/components';
import Sidebar from 'iovisit-museum-theme/components/Blocks/SearchArtworks/Sidebar';
import ViewSearchArtworks from 'iovisit-museum-theme/components/Blocks/SearchArtworks/View';

/**
 * Edit class.
 * @class Edit
 * @extends Component
 */
const Edit = (props) => {
  if (__SERVER__) {
    return <div />;
  }
  return (
    <div className={cx('block', props.data['@type'])}>
      <ViewSearchArtworks {...props} />
      <SidebarPortal selected={props.selected}>
        <Sidebar {...props} />
      </SidebarPortal>
    </div>
  );
};

export default Edit;
